var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctorStand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 148.756,
    height: 270.111,
    viewBox: "0 0 148.756 270.111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#ffc99d;stroke-linecap:round}.cls-1,.cls-10,.cls-2,.cls-3,.cls-5,.cls-7,.cls-9{stroke:#2a3561;stroke-width:.5px;stroke-miterlimit:10}.cls-2{fill:#fff}.cls-3{fill:#37a7f4}.cls-7{fill:#3ba5f4}.cls-5{fill:#2b5889}.cls-8,.cls-9{fill:#2a3561}.cls-10{fill:#31f4cf}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "doctor_1",
    transform: "translate(.339 .258)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    transform: "translate(41.57 120.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_24",
    d: "M0 0H13.596V13.781H0z",
    className: "cls-1",
    transform: "translate(51.616 116.402)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_25",
    d: "M0 0H13.596V13.781H0z",
    className: "cls-1",
    transform: "translate(25.784 116.402)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    d: "M47.718 150.79h48.235v115.162a4.178 4.178 0 0 1-4.146 4.2h-15.1a4.178 4.178 0 0 1-4.146-4.2v-102.91a2.814 2.814 0 0 0-2.793-2.834 2.814 2.814 0 0 0-2.793 2.834v102.91a4.178 4.178 0 0 1-4.146 4.2h-15.1a4.178 4.178 0 0 1-4.146-4.2V150.79z",
    className: "cls-2",
    transform: "translate(-24.043 -150.79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    d: "M39.214 308.828h3.035s-.649 4.782 1.191 6.372 21.389 10.473 21.389 10.473v4.556H25.006a4.978 4.978 0 0 1-4.806-6.086l3.4-15.327h2.021s1.457 2.616 7.3 2.616 6.293-2.604 6.293-2.604z",
    className: "cls-3",
    transform: "translate(25.999 -181.607)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    d: "M102.936 308.828H99.9s.644 4.782-1.191 6.376-21.389 10.473-21.389 10.473v4.556h39.823a4.978 4.978 0 0 0 4.806-6.086l-3.4-15.327h-2.021s-1.457 2.616-7.3 2.616-6.292-2.608-6.292-2.608z",
    className: "cls-3",
    transform: "translate(-77.321 -181.607)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_620",
    fill: "#3ba5f4",
    stroke: "#2a3561",
    strokeWidth: "0.5px",
    d: "M0 0h45.547v7.39H0z",
    transform: "translate(64.214 115.785)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_27",
    d: "M0 0H46.843V70.075H0z",
    className: "cls-5",
    transform: "translate(63.562 48.134)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_49",
    fill: "none",
    stroke: "#2a3561",
    strokeMiterlimit: 10,
    strokeWidth: "0.5px",
    d: "M0 0L0 31.443",
    transform: "translate(87.471 86.765)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    d: "M74.294 68.12h1.851l5.8 46.73-6.73 6.4-6.73-6.4z",
    className: "cls-7",
    transform: "translate(11.478 -13.691)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    d: "M71.206 57.645h6.134a5.091 5.091 0 0 0 5.1-5.1V42.27H66.11v10.28a5.1 5.1 0 0 0 5.096 5.095z",
    className: "cls-1",
    transform: "translate(12.908 -8.65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    d: "M82.527 47.72a14.979 14.979 0 0 1-7.768 4.79c-5.321 1.465-8.138 0-8.138 0v-4.79z",
    className: "cls-8",
    transform: "translate(12.406 -9.713)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    d: "M75.717 60.3a6.355 6.355 0 0 1 4.677 2.125 14.519 14.519 0 0 1-1.409 4.669 5.127 5.127 0 0 1-3.268 2.817 5.127 5.127 0 0 1-3.268-2.817 14.519 14.519 0 0 1-1.409-4.669 6.355 6.355 0 0 1 4.677-2.125z",
    className: "cls-7",
    transform: "translate(10.981 -12.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    d: "M.764 55.83s-1.843 11.656 4.259 14.691l6.44 104.537 3.727 7.092v14.442s15.182-4.4 16.39-11.238c.539-3.051-12.469-81.538-12.469-81.538l12.236 7.559L31 122.033s7.623 2.31 12.469-.459a10.215 10.215 0 0 0 2.085-1.634 15.36 15.36 0 0 0 2.681-17.621L21.557 64.29a12.651 12.651 0 0 0-6.368-4.854C11.487 58.132.764 55.83.764 55.83z",
    className: "cls-2",
    transform: "translate(98.29 -11.295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_50",
    d: "M5.474 23.111L0 0",
    className: "cls-2",
    transform: "translate(111.258 58.599)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    d: "M38.18 110.423l9.475-18.966a2.206 2.206 0 0 0-2.182-3.18l-22.9 2.206a4.866 4.866 0 0 0-3.993 2.89L4.957 124.414a2.2 2.2 0 0 0 2.118 3.086l20.56-.926a4.865 4.865 0 0 0 4.178-2.777z",
    className: "cls-5",
    transform: "translate(96.834 -17.62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    d: "M58.343 15.85a5 5 0 0 1 1.357 2.52v7.865h-3.12v-9.83z",
    className: "cls-9",
    transform: "translate(43.32 -3.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    d: "M73.16 5.46c14.071 0 12.719 8.525 12.719 8.525v17.323c0 9.878-12.719 10.292-12.719 10.292s-12.719-.4-12.719-10.288V13.985S59.089 5.46 73.16 5.46z",
    className: "cls-1",
    transform: "translate(14.02 -1.472)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    d: "M56.114 24.835s2.447-1.441 3.276 1.216c1.087 3.47-3.276 6.424-3.276 6.424z",
    className: "cls-1",
    transform: "translate(43.826 -5.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    d: "M95.54 24.835s-2.447-1.441-3.276 1.216c-1.087 3.47 3.276 6.424 3.276 6.424z",
    className: "cls-1",
    transform: "translate(-21.11 -5.174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    d: "M45.348 115.053l-6.263-2.85-10.94-5.063s-2.769.346-3.872 2.2-1.441 6.875-.523 8.316l2.745 1.876a18.077 18.077 0 0 0-.612 3.727 21.25 21.25 0 0 0 4.564 2.254c5.08 1.787 6.987 1.787 6.987 1.787l7.438 1.562z",
    className: "cls-1",
    transform: "translate(84.522 -21.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    d: "M20.91 116.231s-8.9-3.985-10.28-4.041a4.293 4.293 0 0 0-2.656 1.151L7.74 133.5",
    className: "cls-2",
    transform: "translate(121.421 -22.285)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    d: "M82.64 15.361s4.468-1.489 4.87-4.733-3.11-2.777-3.11-2.777a3.285 3.285 0 0 0-.338-3.582c-1.425-1.594-4.331-.2-5.41 0S77.1 1.564 75.137.686 61.943 2.377 58.49 3.19s-4.13 6.3-4.13 7.913V20s1.827-.507 2.809.169v-4.808a53.492 53.492 0 0 0 13.79-1.69c7.132-2.029 8.71-4.4 8.71-4.4a7.646 7.646 0 0 1 2.971 6.09z",
    className: "cls-9",
    transform: "translate(17.26 -.506)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    d: "M78.994 41.66s-.95.95-3.719.95-3.655-.95-3.655-.95",
    className: "cls-1",
    transform: "translate(11.914 -8.531)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_51",
    d: "M0 0L8.613 4.484",
    className: "cls-1",
    transform: "translate(108.795 88.037)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_52",
    d: "M0 0L8.211 4.122",
    className: "cls-1",
    transform: "translate(107.789 92.231)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_53",
    d: "M0 0L6.706 3.212",
    className: "cls-1",
    transform: "translate(108.272 96.353)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    transform: "translate(0 44.535)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    d: "M120.559 55.83s1.61 11.455-3.711 14.691l-5.3 105.14-4.258 6.44v14.49s-8.541-.258-15.134-8.71c-1.908-2.447 6.794-53.4 6.794-53.4l4.283-23.546-8.308-5.337L100.3 69.9c1.071-5.506 4.009-10.441 9.459-11.785l2.689-.62z",
    className: "cls-2",
    transform: "translate(-46.194 -55.83)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    transform: "translate(0 32.119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    d: "M140.217 101.776l1.586-2.882 7.124 3.912-4.2-4.894 2.359-2.182 4.234 4.572 7.245 3.985.3-.209-1.208-5.136 3.011-.258 2.053 7.511 12.526 6.883-6.738 12.26-12.244-6.73-.008.016-1.465-.805-17.292-9.491 1.666-3.043L136.82 104l1.723-3.148z",
    className: "cls-1",
    transform: "translate(-136.82 -95.73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_54",
    d: "M0 0L9.426 5.184",
    className: "cls-1",
    transform: "translate(1.876 5.208)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_55",
    d: "M0 0L8.686 4.774",
    className: "cls-1",
    transform: "translate(.926 8.694)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    d: "M164.345 106.33s-2.987.4-4.25 2.713-2.624 4.774-2.624 4.774",
    className: "cls-1",
    transform: "translate(-142.545 -97.797)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_56",
    d: "M0 0L1.682 6.834",
    className: "cls-1",
    transform: "translate(25.897 10.465)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    d: "M139.84 58.66l-1.827.427c-5.627 1.006-6.851 8.469-7.623 11.358-1.578 5.836-8.638 34.083-8.638 34.083l-10.152-3.405-6.73 19.489a3.812 3.812 0 0 0 2.391 4.862l22.194 7.358 11.133-61.341",
    className: "cls-2",
    transform: "translate(-76.277 -56.382)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    d: "M90.986 58.613v-2.962s-5 .781-10.731-4l-3.405 6.817s2.415 4.331 9.563 2.946z",
    className: "cls-5",
    transform: "translate(-4.288 -10.479)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    d: "M58.69 58.613v-2.962s5 .781 10.731-4l3.405 6.818s-2.415 4.331-9.563 2.946z",
    className: "cls-5",
    transform: "translate(28.491 -10.479)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    d: "M112.619 211.37s-4.58 5.5-3.912 8.855a7.337 7.337 0 0 0 3.912 4.814z",
    className: "cls-8",
    transform: "translate(-51.512 -41.626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    d: "M38.627 211.37s4.58 5.5 3.912 8.855a7.337 7.337 0 0 1-3.912 4.814z",
    className: "cls-8",
    transform: "translate(74.861 -41.626)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    d: "M28.991 88.891l-2.061 4.741-13.54 1.337 1.843-5.313a2.736 2.736 0 0 1 2.326-1.827l9.974-.95a1.445 1.445 0 0 1 1.458 2.012z",
    className: "cls-10",
    transform: "translate(108.671 -17.348)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    cx: 1.32,
    cy: 1.32,
    r: 1.32,
    className: "cls-8",
    transform: "translate(129.266 72.05)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_57",
    d: "M0 0L4.83 1.771",
    className: "cls-2",
    transform: "translate(45.474 92.674)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    d: "M76.22 24.45l-2.834 8.316a1.772 1.772 0 0 0 1.683 2.343h2.4",
    className: "cls-1",
    transform: "translate(12.096 -5.175)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    d: "M102.415 57.89s-4.258 1.642-3.993 7.543 7.084 31.612 7.084 31.612",
    className: "cls-2",
    transform: "translate(-36.164 -11.696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    d: "M48.223 58.29s4.572 1.32 4.307 7.221-7.084 31.612-7.084 31.612",
    className: "cls-2",
    transform: "translate(59.437 -11.774)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    d: "M49.7 53.77l5.893 1.175s3.317 1 3.317 5.458v17.372h-2.182V59.968s-.032-2.19-1.3-2.866l-5.152-1.127z",
    className: "cls-2",
    transform: "translate(49.644 -10.893)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    d: "M51.892 78.26H49.71v2.769h2.182v-2.536",
    className: "cls-8",
    transform: "translate(56.654 -15.669)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    d: "M100.879 53.77l-5.893 1.175s-3.317 1-3.317 5.458v17.372h2.182V59.968s.032-2.19 1.3-2.866l5.152-1.127z",
    className: "cls-2",
    transform: "translate(-26.111 -10.893)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    d: "M94.5 81.46s4.741-.209 4.741 4.6v17.412h-1.9v-17A2.892 2.892 0 0 0 94.5 83.11z",
    className: "cls-2",
    transform: "translate(-26.752 -16.292)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    d: "M107.841 81.46s-4.741-.209-4.741 4.6v17.412h1.9v-17a2.892 2.892 0 0 1 2.842-3.365z",
    className: "cls-2",
    transform: "translate(-42.275 -16.292)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    d: "M108.1 104.49v3.47h1.119v5.281h-3.276a2.34 2.34 0 0 1-2.343-2.341v-6.41z",
    className: "cls-10",
    transform: "translate(-44.055 -20.784)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    d: "M94.317 104.49v3.47H93.19v5.281h3.284a2.34 2.34 0 0 0 2.343-2.343v-6.408z",
    className: "cls-10",
    transform: "translate(-25.273 -20.784)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    cx: 4.436,
    cy: 4.436,
    r: 4.436,
    className: "cls-10",
    transform: "translate(103.232 65.159)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    cx: 2.713,
    cy: 2.713,
    r: 2.713,
    className: "cls-10",
    transform: "translate(104.955 66.882)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorStand);
export default __webpack_public_path__ + "static/media/doctorStand.6b4abffac988d832ca4d03bd201200ac.svg";
export { ForwardRef as ReactComponent };